import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import TopNav from "@/components/layout/TopNav";

const AUTO_IMG = "/showroom/auto.png";
const MOTO_IMG = "/showroom/moto-hero.webp";

function Side({ to, image, eyebrow, title, accent, testid }) {
  return (
    <motion.div
      className="split-side relative flex-1 min-h-[50dvh] md:min-h-[100dvh] overflow-hidden cursor-pointer group"
      whileHover={{ flexGrow: 1.25 }}
      transition={{ duration: 0.7, ease: [0.83, 0, 0.17, 1] }}
      data-testid={testid}
    >
      <Link to={to} className="absolute inset-0" aria-label={title}>
        <div
          className="absolute inset-0 bg-cover bg-center scale-105 group-hover:scale-100 transition-transform duration-[1200ms] ease-out"
          style={{ backgroundImage: `url(${image})` }}
        />
        <div className="absolute inset-0 hero-scrim" />
        <div className="grain" />
        <div className="relative h-full flex flex-col items-center justify-center text-center px-6 py-8">
          <span
            className="label-eyebrow text-white mb-2 md:mb-4"
            style={{ textShadow: "0 2px 12px rgba(0,0,0,0.75), 0 1px 3px rgba(0,0,0,0.5)" }}
          >
            {eyebrow}
          </span>
          <h2
            className="split-title font-display font-bold uppercase text-white text-[22vw] md:text-[10vw] leading-[0.85]"
            style={{ textShadow: "0 6px 40px rgba(0,0,0,0.4)" }}
          >
            {title}
          </h2>
          <div className="enter-indicator mt-4 md:mt-8">
            <span
              className="label-eyebrow px-5 py-3 border border-white/50 text-white"
              style={{ background: "rgba(0,0,0,0.25)" }}
            >
              ENTRA
            </span>
            <ArrowRight className="text-white" size={22} style={{ color: accent }} />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}

export default function Landing() {
  return (
    <div className="relative">
      <TopNav variant="over-hero" />

      <div className="flex flex-col md:flex-row w-full min-h-[100dvh]" data-testid="landing-split">
        <Side
          to="/auto"
          image={AUTO_IMG}
          eyebrow="Vendita · Noleggio · Usato · Officina"
          title="AUTO"
          accent="#ffffff"
          testid="landing-side-auto"
        />
        <Side
          to="/moto"
          image={MOTO_IMG}
          eyebrow="KTM · Husqvarna Motorcycles · GasGas Trial · Racing Team"
          title="MOTO"
          accent="#FF6600"
          testid="landing-side-moto"
        />
      </div>

      {/* Bottom bar reveal */}
      <div className="absolute bottom-6 left-0 right-0 z-10 pointer-events-none">
        <div className="nsa-container flex items-center justify-center text-white/80 text-xs">
          <span className="label-eyebrow tracking-[0.25em]">
            NSA MOTORS · VIA SERIO 87 · CASNIGO (BG)
          </span>
        </div>
      </div>
    </div>
  );
}
